/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getClubData({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/club")
        .then((response) => {
          // commit('SET_CLUB', response.data)
          localStorage.setItem('clubData', JSON.stringify(response.data));
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  getMailData({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewMails", data)
        .then((response) => {
          // commit('SET_CLUB', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  updateMails({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateMails", data)
        .then((response) => {
          // commit('SET_CLUB', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  previewMail({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/previewMail", data)
        .then((response) => {
          // commit('SET_CLUB', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  getFeedbackData({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewFeedback")
        .then((response) => {
          // commit('SET_FEEDBACKS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  manageFeedback({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/manageFeedback", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  getSubscriptions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/subscription")
        .then((response) => {
          commit('SET_SUBSCRIPTIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getProducts({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/auth/driver/products")
        .then((response) => {
          commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getSubscriptionLink({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/pay/getSubscriptionLink", data)
        .then((response) => {
          // commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  newProduct({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/pay/new", data)
        .then((response) => {
          // commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  changeProduct({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/pay/change", data)
        .then((response) => {
          // commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createModule({ commit }, moduleData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/module/create", moduleData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

}
